module.exports = __webpack_public_path__ + "img/delete_trash.d8f7d306.svg";